import clsx from "clsx";
import type { JSX } from "react/jsx-runtime";

type Props = {
  onClick: () => void;
  label: string;
  className?: string;
};

// TODO: Replace with component from KDS.
export function LinkButton({
  onClick,
  label,
  className,
  ...otherProps
}: Props): JSX.Element {
  return (
    <button
      className={clsx(
        "h-auto min-h-none p-none py-[5px] text-interactive hover:underline",
        className,
      )}
      onClick={onClick}
      type="button"
      {...otherProps}
    >
      {label}
    </button>
  );
}
